import http from 'hub-http/clients/apiClient';
import { formatByDomain, formatByDomainId } from '../formatters/formatSubdomains';
const BASE_URL = 'cos-domains/v1/domains';

// Define interfaces for TypeScript

const fetchSubdomains = ({
  httpClient,
  offset = 0
}) => httpClient.get(BASE_URL, {
  query: {
    skipdnscheck: true,
    limit: 1000,
    offset
  }
});
const fetchAllSubdomains = ({
  httpClient
}) => {
  let allDomains = [];
  let total = 0;
  const fetchNextBatch = (offset = 0) => {
    return fetchSubdomains({
      httpClient,
      offset
    }).then(response => {
      const domains = response.objects || [];
      total = response.total || response.totalCount || 0;
      allDomains = [...allDomains, ...domains];
      const hasMore = allDomains.length < total && domains.length > 0;
      offset += domains.length;
      if (hasMore) {
        return new Promise(resolve => {
          setTimeout(() => resolve(fetchNextBatch(offset)), 50);
        });
      }
      return {
        objects: allDomains
      };
    });
  };
  return fetchNextBatch();
};
export const createGetAllSubdomains = ({
  httpClient
}) => () => fetchAllSubdomains({
  httpClient
}).then(response => formatByDomain(response));
export const createGetAllSubdomainsById = ({
  httpClient
}) => () => fetchAllSubdomains({
  httpClient
}).then(response => formatByDomainId(response));
export const getAllSubdomains = createGetAllSubdomains({
  httpClient: http
});
export const getAllSubdomainsById = createGetAllSubdomainsById({
  httpClient: http
});